import { prodApiConfig } from '../../../config/api.config';
import { Left, Right } from '../../../shared/core/either';
import { Result } from '../../../shared/core/result';
import { APIResponse } from '../../../shared/infrastructure/services/api.response';
import AxiosClient from '../../../shared/infrastructure/services/axios.client';
import { BaseAuthService } from '../../users/services/auth/base_auth.service';
import { Merchant } from '../models/merchant.model';
import { MerchantCategory } from '../models/merchant_category.model';
import { OnboardLiveMerchant } from '../models/onboard_live_merchant.model';
import { BaseMerchantService } from './base_merchant.service';

// Private methods are accessible only from inside the class.
// Protected methods are accessible from inside the class and extending class as well.

class MerchantService implements BaseMerchantService {
    private authService: BaseAuthService;
    private client: AxiosClient;

    public constructor(authService: BaseAuthService, client: AxiosClient) {
        this.authService = authService;
        this.client = client;
    }

    public async getMerchantLiveCategoriesService(): Promise<APIResponse<MerchantCategory[]>> {
        const { SPAY_PROD_SERVER } = prodApiConfig;
        const access_token = this.authService.accessToken();

        try {
            const response = await this.client.get({
                url: `${SPAY_PROD_SERVER}api/v1/merchant-categories`,
                headers: { Authorization: `Bearer ${access_token}`, 'Content-Type': 'application/json' }
            });

            const categories: MerchantCategory[] = response.data['content'];

            return new Right(Result.ok<MerchantCategory[]>(categories));
        } catch (error: any) {
            const { message } = error.response.data.error;
            return new Left(message);
        }
    }

    public async registerLiveMerchant(data: OnboardLiveMerchant): Promise<APIResponse<Merchant>> {
        const { SPAY_PROD_SERVER } = prodApiConfig;
        const access_token = this.authService.accessToken();

        try {
            const response = await this.client.post({
                url: `${SPAY_PROD_SERVER}api/v1/merchants/user`,
                data: { ...data },
                headers: { Authorization: `Bearer ${access_token}`, 'Content-Type': 'application/json' }
            });

            const merchant: Merchant = response.data;

            return new Right(Result.ok<Merchant>(merchant));
        } catch (error: any) {
            const { message } = error.response.data.error;
            return new Left(message);
        }
    }

    public async getLiveMerchantByEmail(email: string): Promise<APIResponse<Merchant>> {
        const { SPAY_PROD_SERVER } = prodApiConfig;
        const access_token = this.authService.accessToken();

        try {
            const response = await this.client.get({
                url: `${SPAY_PROD_SERVER}api/v1/merchants/user-email`,
                params: { userEmail: email },
                headers: { Authorization: `Bearer ${access_token}`, 'Content-Type': 'application/json'}
            });

            const merchant: Merchant = response.data;

            return new Right(Result.ok<Merchant>(merchant));
        } catch (err: any) {
            const { message } = err.response.data.error;
            return new Left(message);
        }
    }
}

export default MerchantService;
